// All translations live here. Keys are stable identifiers; values change per language.
// Add new strings as you build pages — never hard-code copy in components.

export const translations = {
  ru: {
    common: {
      home: 'Главная',
      services: 'Услуги',
      calculator: 'Калькулятор',
      about: 'О компании',
      faq: 'FAQ',
      contacts: 'Контакты',
      shop: 'Витрина',
      login: 'Войти',
      register: 'Регистрация',
      orderNow: 'Заказать доставку',
      learnMore: 'Подробнее',
      callUs: 'Позвонить',
      writeUs: 'Написать',
      pricePerKg: 'за кг',
      days: 'дней',
      minWeight: 'мин. вес',
      kg: 'кг',
      from: 'от',
      currency: 'USD',
    },
    nav: {
      ariaPrimary: 'Основная навигация',
    },
    seo: {
      home: {
        title: 'Карго из Турции в Россию от $4/кг — Стамбул→Москва',
        description: 'Карго RENEXPRESS: доставка грузов из Турции в Россию от $4/кг. Авто (14-18 дней) и авиа (3-8 дней) из Стамбула в Москву. Склад на Южнопортовой, отслеживание в приложении.',
      },
      services: {
        title: 'Услуги доставки из Турции — авиа и авто карго | RENEXPRESS',
        description: 'Тарифы доставки из Турции: AVTO EXPRESS $4/кг (14-18 дней), AVIA U3 $8.5/кг (4-5 дней), AVIA EX MARKA $10/кг (3-4 дня). Минимальный вес 10 кг.',
      },
      calculator: {
        title: 'Калькулятор стоимости доставки из Турции в Россию | RENEXPRESS',
        description: 'Рассчитайте стоимость доставки груза из Турции в Россию: введите вес и категорию товара, получите цену по всем трём тарифам RENEXPRESS.',
      },
      about: {
        title: 'О компании RENEXPRESS (RENCARGO) — карго Турция–Россия',
        description: 'RENEXPRESS — карго компания с офисами в Стамбуле и Москве. Часть группы RENCARGO TRANSPORTATION, RENSHOPPING ISTANBUL, RENFABRIK. Работаем с 2017 года.',
      },
      faq: {
        title: 'Вопросы и ответы о доставке из Турции | RENEXPRESS',
        description: 'Ответы на частые вопросы: сроки и стоимость доставки из Турции, минимальный вес, какие товары принимаем, таможенное оформление, отслеживание грузов.',
      },
      contacts: {
        title: 'Контакты RENEXPRESS — склад в Москве, офис в Стамбуле',
        description: 'Телефоны RENEXPRESS: +90 551 189 82 88 (Турция), +7 928 970 70 10 (Россия). Склад: Москва, ул. Южнопортовая 7а. Email: Inforencargo@gmail.com.',
      },
      shop: {
        title: 'Витрина товаров поставщиков из Турции | RENEXPRESS',
        description: 'Каталог товаров от наших партнёров-поставщиков в Турции. Прямая закупка из Стамбула с доставкой через RENEXPRESS.',
      },
      deliveryTurkeyRussia: {
        title: 'Доставка из Турции в Россию — карго от $4/кг | RENEXPRESS',
        description: 'Грузоперевозки Турция–Россия: шесть тарифов, склады в Стамбуле и Москве, таможенное сопровождение. Авто 14-18 дней или авиа 3-8 дней.',
      },
      deliveryIstanbulMoscow: {
        title: 'Карго Стамбул — Москва: сроки, склад, самовывоз | RENEXPRESS',
        description: 'Прямой маршрут Стамбул→Москва: приём товара в Стамбуле, выдача на складе Южнопортовая 7а в Москве, бесплатная пересылка транспортной компанией по России. Авто 14–18 дней, авиа 3–5.',
      },
      customsClearance: {
        title: 'Растаможка и таможенное оформление грузов из Турции',
        description: 'Растаможка и таможенное оформление при импорте из Турции в Россию: документы, коды ТН ВЭД, декларирование. Включено в стоимость карго RENEXPRESS.',
      },
      marketplace: {
        title: 'Доставка из Турции для Wildberries и OZON — «Честный знак» | RENEXPRESS',
        description: 'Легальный импорт товаров из Турции для продажи на Wildberries и OZON: таможенное оформление, коды ТН ВЭД, маркировка «Честный знак», договор. Авиа и авто из Стамбула в Москву от $4/кг.',
      },
    },
    home: {
      heroTitle: 'Карго из Турции в Россию',
      heroSubtitle: 'Пять тарифов доставки от $4 за кг. Из Стамбула в Москву за 3-18 дней с отслеживанием в приложении.',
    },
    services: {
      pageTitle: 'Тарифы доставки из Турции',
      pageSubtitle: 'Пять тарифов доставки груза из Стамбула в Москву',
    },
  },

  en: {
    common: {
      home: 'Home',
      services: 'Services',
      calculator: 'Calculator',
      about: 'About',
      faq: 'FAQ',
      contacts: 'Contacts',
      shop: 'Shop',
      login: 'Sign in',
      register: 'Sign up',
      orderNow: 'Order delivery',
      learnMore: 'Learn more',
      callUs: 'Call us',
      writeUs: 'Write to us',
      pricePerKg: 'per kg',
      days: 'days',
      minWeight: 'min. weight',
      kg: 'kg',
      from: 'from',
      currency: 'USD',
    },
    nav: {
      ariaPrimary: 'Primary navigation',
    },
    seo: {
      home: {
        title: 'RENEXPRESS — Cargo from Turkey to Russia | Istanbul-Moscow Freight',
        description: 'RENEXPRESS cargo: shipments from Turkey to Russia from $4/kg. Road (14-18 days) and air (3-8 days) freight from Istanbul to Moscow. Warehouse in Moscow, in-app tracking.',
      },
      services: {
        title: 'Cargo Delivery Services from Turkey — Air & Road | RENEXPRESS',
        description: 'Shipping options from Turkey: AVTO EXPRESS $4/kg (14-18 days), AVIA U3 $8.5/kg (4-5 days), AVIA EX MARKA $10/kg (3-4 days). Minimum weight 10 kg.',
      },
      calculator: {
        title: 'Turkey to Russia Shipping Cost Calculator | RENEXPRESS',
        description: 'Calculate cargo cost from Turkey to Russia: enter weight and category, get prices across all three RENEXPRESS tariffs.',
      },
      about: {
        title: 'About RENEXPRESS — Turkey-Russia Cargo Since 2017',
        description: 'RENEXPRESS — cargo company with offices in Istanbul and Moscow. Part of the RENCARGO TRANSPORTATION, RENSHOPPING ISTANBUL, RENFABRIK group. Operating since 2017.',
      },
      faq: {
        title: 'Turkey Cargo FAQ — Shipping Questions Answered | RENEXPRESS',
        description: 'Common questions about cargo from Turkey: timing and pricing, minimum weight, accepted goods, customs clearance, shipment tracking.',
      },
      contacts: {
        title: 'RENEXPRESS Contacts — Warehouse in Moscow, Office in Istanbul',
        description: 'RENEXPRESS phones: +90 551 189 82 88 (Turkey), +7 928 970 70 10 (Russia). Warehouse: Moscow, Yuzhnoportovaya 7a. Email: Inforencargo@gmail.com.',
      },
      shop: {
        title: 'Catalog of Turkish Supplier Goods | RENEXPRESS',
        description: 'Catalog of goods from our partner suppliers in Turkey. Direct sourcing from Istanbul with delivery via RENEXPRESS.',
      },
      deliveryTurkeyRussia: {
        title: 'Cargo from Turkey to Russia — Freight from $4/kg | RENEXPRESS',
        description: 'Turkey-Russia freight: five tariffs, warehouses in Istanbul and Moscow, customs assistance. Road in 14-18 days or air in 3-8 days.',
      },
      deliveryIstanbulMoscow: {
        title: 'Istanbul to Moscow Cargo: Transit, Warehouse, Pickup | RENEXPRESS',
        description: 'Direct Istanbul→Moscow route: intake in Istanbul, handover at the Yuzhnoportovaya warehouse in Moscow, free onward forwarding across Russia. Road 14–18 days, air 3–5.',
      },
      customsClearance: {
        title: 'Customs Clearance for Imports from Turkey | RENEXPRESS',
        description: 'Full customs support for imports from Turkey to Russia: documents, HS codes, declaration. Included in the RENEXPRESS cargo price.',
      },
      marketplace: {
        title: 'Turkey Import for Wildberries & OZON — Chestny Znak | RENEXPRESS',
        description: 'Legal import from Turkey for selling on Wildberries and OZON: customs clearance, HS codes, «Chestny Znak» marking, service contract. Air and road from Istanbul to Moscow from $4/kg.',
      },
    },
    home: {
      heroTitle: 'Cargo from Turkey to Russia',
      heroSubtitle: 'Six tariffs from $4 per kg. From Istanbul to Moscow in 3-18 days with in-app tracking.',
    },
    services: {
      pageTitle: 'Turkey Shipping Tariffs',
      pageSubtitle: 'Five shipping tariffs from Istanbul to Moscow',
    },
  },

  tr: {
    common: {
      home: 'Ana sayfa',
      services: 'Hizmetler',
      calculator: 'Hesaplayıcı',
      about: 'Hakkımızda',
      faq: 'SSS',
      contacts: 'İletişim',
      shop: 'Mağaza',
      login: 'Giriş',
      register: 'Kayıt',
      orderNow: 'Sipariş ver',
      learnMore: 'Daha fazla',
      callUs: 'Bizi arayın',
      writeUs: 'Bize yazın',
      pricePerKg: 'kg başına',
      days: 'gün',
      minWeight: 'min. ağırlık',
      kg: 'kg',
      from: 'başlangıç',
      currency: 'USD',
    },
    nav: {
      ariaPrimary: 'Ana navigasyon',
    },
    seo: {
      home: {
        title: 'RENEXPRESS — Türkiye Rusya kargo | İstanbul Moskova taşımacılık',
        description: 'RENEXPRESS kargo: Türkiye\'den Rusya\'ya $4/kg\'dan başlayan taşımacılık. Karayolu (14-18 gün) ve havayolu (3-8 gün) İstanbul-Moskova. Moskova\'da depo, uygulama içi takip.',
      },
      services: {
        title: 'Türkiye Kargo Hizmetleri — Hava ve Karayolu | RENEXPRESS',
        description: 'Türkiye\'den gönderim tarifeleri: AVTO EXPRESS $4/kg (14-18 gün), AVIA U3 $8.5/kg (4-5 gün), AVIA EX MARKA $10/kg (3-4 gün). Minimum ağırlık 10 kg.',
      },
      calculator: {
        title: 'Türkiye-Rusya Kargo Ücret Hesaplayıcı | RENEXPRESS',
        description: 'Türkiye\'den Rusya\'ya kargo maliyetini hesaplayın: ağırlık ve kategori girin, üç RENEXPRESS tarifesinde fiyat alın.',
      },
      about: {
        title: 'RENEXPRESS Hakkında — 2017\'den Beri Türkiye-Rusya Kargo',
        description: 'RENEXPRESS — İstanbul ve Moskova ofisleri olan kargo şirketi. RENCARGO TRANSPORTATION, RENSHOPPING ISTANBUL, RENFABRIK grubunun parçası. 2017\'den bu yana faaliyette.',
      },
      faq: {
        title: 'Türkiye Kargo SSS — Sevkiyat Soruları | RENEXPRESS',
        description: 'Türkiye\'den kargo hakkında sık sorulan sorular: süre ve fiyat, minimum ağırlık, kabul edilen mallar, gümrük, gönderi takibi.',
      },
      contacts: {
        title: 'RENEXPRESS İletişim — Moskova Depo, İstanbul Ofis',
        description: 'RENEXPRESS telefonlar: +90 551 189 82 88 (Türkiye), +7 928 970 70 10 (Rusya). Depo: Moskova, Yujnoportovaya 7a. E-posta: Inforencargo@gmail.com.',
      },
      shop: {
        title: 'Türk Tedarikçi Ürünleri Kataloğu | RENEXPRESS',
        description: 'Türkiye\'deki ortak tedarikçilerimizden ürünler. İstanbul\'dan doğrudan tedarik, RENEXPRESS ile teslimat.',
      },
      deliveryTurkeyRussia: {
        title: 'Türkiye\'den Rusya\'ya Kargo — $4/kg\'dan | RENEXPRESS',
        description: 'Türkiye-Rusya taşımacılık: beş tarife, İstanbul ve Moskova depoları, gümrük desteği. Karayolu 14-18 gün veya havayolu 3-8 gün.',
      },
      deliveryIstanbulMoscow: {
        title: 'İstanbul – Moskova Kargo: Süre, Depo, Teslim | RENEXPRESS',
        description: 'Doğrudan İstanbul→Moskova rotası: İstanbul\'da teslim alma, Moskova Yujnoportovaya deposunda teslim, Rusya geneline ücretsiz aktarım. Karayolu 14–18, havayolu 3–5 gün.',
      },
      customsClearance: {
        title: 'Türkiye\'den İthalat için Gümrük İşlemleri | RENEXPRESS',
        description: 'Türkiye\'den Rusya\'ya ithalat için tam gümrük desteği: belgeler, GTİP kodları, beyan. RENEXPRESS kargo fiyatına dahildir.',
      },
      marketplace: {
        title: 'Wildberries ve OZON için Türkiye\'den İthalat | RENEXPRESS',
        description: 'Wildberries ve OZON\'da satış için Türkiye\'den yasal ithalat: gümrük işlemleri, GTİP kodları, «Çestnıy Znak» etiketleme, sözleşme. İstanbul\'dan Moskova\'ya hava ve karayolu, $4/kg\'dan.',
      },
    },
    home: {
      heroTitle: 'Türkiye\'den Rusya\'ya kargo',
      heroSubtitle: 'Altı tarife, $4/kg\'dan başlayan fiyatlarla. İstanbul\'dan Moskova\'ya 3-18 günde, uygulama içi takip.',
    },
    services: {
      pageTitle: 'Türkiye Kargo Tarifeleri',
      pageSubtitle: 'İstanbul\'dan Moskova\'ya beş kargo tarifesi',
    },
  },
};

export default translations;
